import storage from "store";
import cookie from '@/utils/cookie'

import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });

const whiteList = [
    "/login/",
    "/",
    "/realinfo/",
    "/game/",
    "/giftbag/",
    "/realinfo/detail/",
    "/forgotPass/",
    "/register/",
    "/404/",
];

const isClient = process.client;
// // minimum 设置开始时最低百分比，默认是0.08
// NProgress.configure( { minimum : 0.1 } )
// // template改变进度条的HTML结构。为了保证进度条正常工作，需要一个包含role='bar' 属性的元素
// NProgress.configure( {
//   template : "<div class='....'>...</div>"
// } )
// // ease和speed ease可传递CSS3缓冲动画字符串（如ease、linear、ease-in、ease-out、ease-in-out、cubic-bezier）。speed为动画速度（默认200，单位ms）
// NProgress.configure( { easing : 'ease', speed : 500 } )
// // trickle 是否显示进度条，默认：true
// NProgress.configure( { trickle : false } )
// // trickleSpeed设置每次进度条步进速度(ms)
// NProgress.configure( { trickleSpeed : 200 } )
// // showSpinner是否显示环形进度动画，默认true
// NProgress.configure( { showSpinner : false } )
// // parent 指定改变的父容器，默认body
// NProgress.configure( { parent : '#container' } )

export default ({ app, store }) => {
    app.router.beforeEach(async (to, from, next) => {
        // console.log(NProgress.start());
        // isClient && NProgress.start()
        if (isClient) {
            const hasToken = storage.get("ACCESS_TOKEN") || cookie.get('ACCESS_TOKEN'); // 判断是否有token
            if (hasToken !== undefined) {
                if (to.path === "/login/") {
                    // 登录过就不能访问登录界面，需要中断这一次路由守卫，执行下一次路由守卫，并且下一次守卫的to是主页
                    next({ path: "/" });
                    NProgress.done();
                } else {
                    const hasRoles =
                        store.getters.roles && store.getters.roles.length > 0; // 判断是否已生成过动态路由
                    if (hasRoles) {
                        next();
                    } else {
                        store.dispatch("get_user_info");
                    }
                }
            } else {
                if (whiteList.indexOf(to.path) !== -1) {
                    // 在免登录白名单，直接进入
                    next();
                } else {
                    next("/login/"); // 否则全部重定向到登录页
                    NProgress.done();
                }
            }
        }
        next();
        isClient && NProgress.done();
    });

    app.router.afterEach(() => {
        isClient && NProgress.done();
    });
};
